import type { TmrLocation, TmrSimpleAttributesMap } from 'stylewhere/api'

// Empty placeholder matches the rest of the Item Info fields ("---").
export const EMPTY_VALUE = '---'

export const formatLocation = (location?: TmrLocation): string => {
  if (!location) return EMPTY_VALUE
  const code = (location.code ?? '').trim()
  const description = (location.description ?? '').trim()
  if (code && description) return `${code} - ${description}`
  return code || description || EMPTY_VALUE
}

// Matches the "zone" row across configurations:
// - core/standard: server-configured item attribute whose code is `zone`
// - Cucinelli override: injected attribute with key `zone-attribute`
const isZoneAttribute = (attr: TmrSimpleAttributesMap): boolean =>
  attr.key === 'zone' || attr.key === 'zone-attribute' || attr.label === 'zone'

// Inserts the Location row right after the "zone" attribute,
// falling back to the top of the list when no zone attribute is present.
export const insertLocationRow = (
  attrs: TmrSimpleAttributesMap[],
  locationAttr: TmrSimpleAttributesMap
): TmrSimpleAttributesMap[] => {
  const zoneIndex = attrs.findIndex(isZoneAttribute)
  if (zoneIndex === -1) return [locationAttr, ...attrs]
  return [...attrs.slice(0, zoneIndex + 1), locationAttr, ...attrs.slice(zoneIndex + 1)]
}
